import React from "react"

import Layout from "../../components/Layout/Layout"

const Error = props => {
  return (
    <Layout>
      <h1>404 Page Not Found!</h1>
    </Layout>
  )
}

export { Error }

export default Error